/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Subscription,
    SubscriptionFromJSON,
    SubscriptionFromJSONTyped,
    SubscriptionToJSON,
} from './';

/**
 * 
 * @export
 * @interface TestCloudAccountCredentialsResponse
 */
export interface TestCloudAccountCredentialsResponse {
    /**
     * 
     * @type {Array<Subscription>}
     * @memberof TestCloudAccountCredentialsResponse
     */
    subscriptions: Array<Subscription>;
}

export function TestCloudAccountCredentialsResponseFromJSON(json: any): TestCloudAccountCredentialsResponse {
    return TestCloudAccountCredentialsResponseFromJSONTyped(json, false);
}

export function TestCloudAccountCredentialsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestCloudAccountCredentialsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subscriptions': ((json['subscriptions'] as Array<any>).map(SubscriptionFromJSON)),
    };
}

export function TestCloudAccountCredentialsResponseToJSON(value?: TestCloudAccountCredentialsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subscriptions': ((value.subscriptions as Array<any>).map(SubscriptionToJSON)),
    };
}


